(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("liferay-widgets-react-web/js/liferay-widgets-react-web"), require("keymirror"), require("react"), require("react-bootstrap"), require("lwr-client"), require("prop-types"), require("base-portlet/js/base-portlet"), require("datefns"));
	else if(typeof define === 'function' && define.amd)
		define(["liferay-widgets-react-web/js/liferay-widgets-react-web", "keymirror", "react", "react-bootstrap", "lwr-client", "prop-types", "base-portlet/js/base-portlet", "datefns"], factory);
	else if(typeof exports === 'object')
		exports["journal-portlet"] = factory(require("liferay-widgets-react-web/js/liferay-widgets-react-web"), require("keymirror"), require("react"), require("react-bootstrap"), require("lwr-client"), require("prop-types"), require("base-portlet/js/base-portlet"), require("datefns"));
	else
		root["journal-portlet"] = factory(root["liferay-widgets-react-web/js/liferay-widgets-react-web"], root["keymirror"], root["react"], root["react-bootstrap"], root["lwr-client"], root["prop-types"], root["base-portlet/js/base-portlet"], root["datefns"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_9__, __WEBPACK_EXTERNAL_MODULE_12__, __WEBPACK_EXTERNAL_MODULE_14__, __WEBPACK_EXTERNAL_MODULE_16__, __WEBPACK_EXTERNAL_MODULE_17__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.JournalActions = exports.JournalListItem = exports.JournalListWidget = exports.JournalWebApi = exports.JournalEntry = undefined;
	
	var _StoreFactory = __webpack_require__(2);
	
	Object.keys(_StoreFactory).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _StoreFactory[key];
	        }
	    });
	});
	
	var _JournalListWidget = __webpack_require__(7);
	
	Object.defineProperty(exports, 'JournalListWidget', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_JournalListWidget).default;
	    }
	});
	
	var _JournalListItem = __webpack_require__(13);
	
	Object.defineProperty(exports, 'JournalListItem', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_JournalListItem).default;
	    }
	});
	
	var _JournalActions = __webpack_require__(10);
	
	Object.defineProperty(exports, 'JournalActions', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_JournalActions).default;
	    }
	});
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _JournalWebApi = __webpack_require__(11);
	
	var _JournalWebApi2 = _interopRequireDefault(_JournalWebApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_liferayWidgetsReactWeb.AppContext.registerBundle({
	    webApis: { JournalWebApi: _JournalWebApi2.default }
	});
	
	//import { default as JournalEntryLoginRenderer } from './components/JournalEntryLoginRenderer';
	//import { default as JournalEntryLogoutRenderer } from './components/JournalEntryLogoutRenderer';
	
	var JournalEntry = exports.JournalEntry = undefined;
	//export const JournalRenderer_LOGIN = JournalEntryLoginRenderer;
	//export const JournalRenderer_LOGOUT = JournalEntryLogoutRenderer;
	
	exports.JournalWebApi = _JournalWebApi2.default;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getJournalStore = getJournalStore;
	
	var _JournalStore = __webpack_require__(3);
	
	var _JournalStore2 = _interopRequireDefault(_JournalStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var journalStoreInstance = void 0; /**
	                                    * Created by Carsten Bühler
	                                    * User: CBuehler on 28.01.2016
	                                    * Copyright: xdot GmbH 2015
	                                    */
	
	function getJournalStore(AppContext) {
	  return journalStoreInstance || (journalStoreInstance = AppContext.createStore(_JournalStore2.default));
	}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _Constants = __webpack_require__(5);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * User: CBuehler on 12.01.2016
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright: xdot GmbH 2016
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var JournalStore = function (_ClassRemoteDataStore) {
	    _inherits(JournalStore, _ClassRemoteDataStore);
	
	    function JournalStore(Dispatcher) {
	        _classCallCheck(this, JournalStore);
	
	        return _possibleConstructorReturn(this, _ClassRemoteDataStore.call(this, Dispatcher, _Constants.ClassNames.JournalEntry));
	    }
	
	    return JournalStore;
	}(_liferayWidgetsReactWeb.ClassRemoteDataStore);
	
	exports.default = JournalStore;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MAX_JOURNAL_FILTER_DATE_RANGE_DAYS = exports.JournalEntryCategories = exports.ClassNames = undefined;
	
	var _keymirror = __webpack_require__(6);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClassNames = exports.ClassNames = (0, _keymirror2.default)({
	    JournalEntry: null
	}); /**
	     * Created by Carsten Bühler
	     * User: CBuehler on 08.12.2015
	     * Copyright: xdot GmbH 2015
	     */
	
	var JournalEntryCategories = exports.JournalEntryCategories = (0, _keymirror2.default)({
	    CHANGE_RECORD: null,
	    ALARMLEVEL_SET: null,
	    ALARMLEVEL_MANUAL: null,
	    OPERATION_PLANNING: null,
	    TASK_MANAGEMENT: null,
	    ACTIVATION_MATRIX: null,
	    SITUATION_MESSAGE: null,
	    SITUATION_MAP: null,
	    FRB_CHART: null,
	    WATER_LEVEL_CHART: null,
	    PRECIPITATION_STATION_CHART: null,
	    REAL_PRECIPITATION_STATION_CHART: null,
	    WEBCAM: null,
	    WEATHER_WARNING: null,
	    WATERLEVEL_MESSAGE: null
	});
	
	var MAX_JOURNAL_FILTER_DATE_RANGE_DAYS = exports.MAX_JOURNAL_FILTER_DATE_RANGE_DAYS = 14;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 19.02.2016
	 * Copyright: xdot GmbH 2015
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(8);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(9);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _JournalActions = __webpack_require__(10);
	
	var _JournalActions2 = _interopRequireDefault(_JournalActions);
	
	var _JournalListItem = __webpack_require__(13);
	
	var _JournalListItem2 = _interopRequireDefault(_JournalListItem);
	
	var _StoreFactory = __webpack_require__(2);
	
	var _JournalFilters = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JournalListC = _liferayWidgetsReactWeb.DataLinkContainer.link(_liferayWidgetsReactWeb.ScrollableDataList, ['list'], (0, _StoreFactory.getJournalStore)(_liferayWidgetsReactWeb.AppContext));
	
	var JournalListWidget = function (_PortletComponent) {
	    _inherits(JournalListWidget, _PortletComponent);
	
	    function JournalListWidget(props) {
	        _classCallCheck(this, JournalListWidget);
	
	        var _this = _possibleConstructorReturn(this, _PortletComponent.call(this, props));
	
	        _this.DATA = {
	            JOURNAL_ENTRIES: _this.withCtx('JournalEntries')
	        };
	
	        _this.LOCAL_CONFIG = _this.withCtx('Fliwas_Journal_List_Widget_Category_Keys_' + _this.props.scopeGroupId + '_' + _this.props.plid + '_' + _this.props.portletId);
	
	        _this._asyncOpt = _this._asyncOpt.bind(_this);
	        return _this;
	    }
	
	    JournalListWidget.prototype.componentDidMount = function componentDidMount() {
	        var localConfig = JSON.parse(localStorage.getItem(this.LOCAL_CONFIG));
	        var categoryKeys = localConfig && localConfig.properties && localConfig.properties.categoryKeys || '';
	        _JournalActions2.default.search(this.DATA.JOURNAL_ENTRIES, {
	            categoryKeys: categoryKeys && categoryKeys.length > 0 ? categoryKeys : [],
	            start: 0,
	            end: _liferayWidgetsReactWeb.AppContext.DEFAULT_LIST_SIZE
	        });
	    };
	
	    JournalListWidget.prototype.moreJournalEntries = function moreJournalEntries(query) {
	        _JournalActions2.default.moreItems(this.DATA.JOURNAL_ENTRIES, query);
	    };
	
	    JournalListWidget.prototype.renderPortlet = function renderPortlet() {
	
	        return _react2.default.createElement(
	            _reactBootstrap.Container,
	            { fluid: true },
	            _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 12, lg: 4, xl: 2 },
	                    _react2.default.createElement(_JournalFilters.JournalFilters, {
	                        localConfigKey: this.LOCAL_CONFIG,
	                        listName: this.DATA.JOURNAL_ENTRIES
	                    })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 12, lg: 8, xl: 10 },
	                    _react2.default.createElement(JournalListC, {
	                        style: { height: 'calc(100vh - 120px)' },
	                        list: this.DATA.JOURNAL_ENTRIES,
	                        ListItem: _JournalListItem2.default,
	                        onClickMore: this.moreJournalEntries.bind(this)
	                    })
	                )
	            )
	        );
	    };
	
	    JournalListWidget.prototype.isConfigurationNeeded = function isConfigurationNeeded() {
	        return false;
	    };
	
	    return JournalListWidget;
	}(_liferayWidgetsReactWeb.PortletComponent);
	
	exports.default = JournalListWidget;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_8__;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_9__;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _Constants = __webpack_require__(5);
	
	var _JournalWebApi = __webpack_require__(11);
	
	var _JournalWebApi2 = _interopRequireDefault(_JournalWebApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var className = _Constants.ClassNames.JournalEntry; /**
	                                                     * Created by Carsten Bühler
	                                                     * User: CBuehler on 22.10.2015
	                                                     * Copyright: xdot GmbH 2015
	                                                     */
	
	
	var api = 'JournalWebApi';
	
	exports.default = {
	    addEntry: function addEntry(_ref, formId, closeForm) {
	        var groupId = _ref.groupId,
	            className = _ref.className,
	            classPK = _ref.classPK,
	            type = _ref.type,
	            attachments = _ref.attachments,
	            message = _ref.message;
	        return _liferayWidgetsReactWeb.FormActions.submitForm(_JournalWebApi2.default.addEntry, { groupId: groupId, className: className, classPK: classPK, type: type, attachments: attachments, message: message }, formId, closeForm);
	    },
	
	    search: function search(name, query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.list(name, className, query, api + '.' + 'search');
	    },
	
	    moreItems: function moreItems(name, query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.moreItems(name, className, query);
	    }
	};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _lwrClient = __webpack_require__(12);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 08.12.2015
	 * Copyright: xdot GmbH 2015
	 */
	
	var journalEntryService = function journalEntryService(m, o) {
	    return _lwrClient.Client.invoke('/journal.journalentry/' + m, o);
	};
	var journalEntryServiceWithContext = function journalEntryServiceWithContext(m, o, c) {
	    return _lwrClient.Client.invokeWithContext('/journal.journalentry/' + m, o, c);
	};
	
	var api = {
	    addEntry: function addEntry(_ref) {
	        var groupId = _ref.groupId,
	            className = _ref.className,
	            classPK = _ref.classPK,
	            type = _ref.type,
	            attachments = _ref.attachments,
	            message = _ref.message;
	
	
	        var data = {
	            groupId: groupId, type: type, attachments: attachments, message: JSON.stringify(message)
	        };
	        if (className) {
	            data.className = className;
	        }
	        if (classPK) {
	            data.classPK = classPK;
	        }
	        var formData = _liferayWidgetsReactWeb.FormDataUtil.toFormData(data);
	        var d2 = {};
	        for (var _iterator = formData.entries(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	            var _ref2;
	
	            if (_isArray) {
	                if (_i >= _iterator.length) break;
	                _ref2 = _iterator[_i++];
	            } else {
	                _i = _iterator.next();
	                if (_i.done) break;
	                _ref2 = _i.value;
	            }
	
	            var pair = _ref2;
	
	            d2[pair[0]] = pair[1];
	        }
	        console.log('Entry data', data, d2);
	        return journalEntryService('add-journal-entry.1', formData);
	    },
	    search: function search(query) {
	        return journalEntryServiceWithContext('search.3', {
	            start: query.start,
	            end: query.end
	        }, {
	            categoryKeys: query.categoryKeys.toString(),
	            startDate: query.startDate && query.startDate.getTime(),
	            endDate: query.endDate && query.endDate.getTime()
	        });
	    }
	};
	
	_liferayWidgetsReactWeb.ApiUtil.namedApi('JournalWebApi', api);
	
	exports.default = api;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_12__;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(8);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JournalListItem = function JournalListItem(_ref) {
	    var item = _ref.item;
	
	    var journalEntry = item;
	
	    var journalMessage = undefined;
	    try {
	        journalMessage = journalEntry.message && JSON.parse(journalEntry.message);
	    } catch (e) {
	        console.error('Error parsing journal.message', journalMessage);
	    }
	
	    return _react2.default.createElement(
	        _liferayWidgetsReactWeb.AmdRequireComponent,
	        { dependencies: ['JournalRenderer/' + journalEntry.type] },
	        function (Renderer) {
	            return _react2.default.createElement(Renderer, { message: journalMessage, entry: journalEntry });
	        }
	    );
	}; /**
	    * Created by Carsten Bühler
	    * User: CBuehler on 12.02.2016
	    * Copyright: xdot GmbH 2015
	    */
	
	JournalListItem.propTypes = {
	    item: _propTypes2.default.object
	};
	
	exports.default = JournalListItem;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_14__;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.JournalFilters = undefined;
	
	var _react = __webpack_require__(8);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(9);
	
	var _basePortlet = __webpack_require__(16);
	
	var _JournalActions = __webpack_require__(10);
	
	var _JournalActions2 = _interopRequireDefault(_JournalActions);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _Constants = __webpack_require__(5);
	
	var _datefns = __webpack_require__(17);
	
	var _datefns2 = _interopRequireDefault(_datefns);
	
	var _FilterDefinitions = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JournalFilters = exports.JournalFilters = function JournalFilters(_ref) {
	    var localConfigKey = _ref.localConfigKey,
	        listName = _ref.listName;
	
	    var _useState = (0, _react.useState)(false),
	        showFilters = _useState[0],
	        setShowFilters = _useState[1];
	
	    var localConfig = JSON.parse(localStorage.getItem(localConfigKey));
	    var defaultCategoryKeys = localConfig && localConfig.properties && localConfig.properties.categoryKeys || '';
	    var dateFilterActive = localConfig && localConfig.properties && localConfig.properties.dateFilterActive;
	    var start = localConfig && localConfig.properties && localConfig.properties.startDate;
	    var end = localConfig && localConfig.properties && localConfig.properties.endDate;
	
	    var _useState2 = (0, _react.useState)({
	        startDate: start && new Date(start),
	        endDate: start && new Date(end)
	    }),
	        _useState2$ = _useState2[0],
	        startDate = _useState2$.startDate,
	        endDate = _useState2$.endDate,
	        setStartEndDate = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(defaultCategoryKeys.toString()),
	        categoryKeys = _useState3[0],
	        setCategoryKeys = _useState3[1];
	
	    var _useState4 = (0, _react.useState)(dateFilterActive),
	        useDateFilter = _useState4[0],
	        setUseDateFilter = _useState4[1];
	
	    (0, _react.useEffect)(function () {
	        var reportWindowSize = function reportWindowSize() {
	            var width = window.innerWidth;
	            if (width >= window.BREAKPOINT_LG) {
	                setShowFilters(true);
	            }
	        };
	        window.addEventListener('resize', reportWindowSize);
	        reportWindowSize();
	
	        return function () {
	            return window.removeEventListener('resize', reportWindowSize);
	        };
	    }, []);
	
	    (0, _react.useEffect)(function () {
	        if (!useDateFilter) {
	            setStartEndDate({ startDate: null, endDate: null });
	        }
	    }, [useDateFilter]);
	
	    (0, _react.useEffect)(function () {
	        _liferayWidgetsReactWeb.ConfigActions.updateLocalConfig(localConfigKey, {
	            categoryKeys: categoryKeys,
	            dateFilterActive: useDateFilter,
	            startDate: startDate && startDate.getTime(),
	            endDate: endDate && endDate.getTime()
	        });
	        _JournalActions2.default.search(listName, {
	            categoryKeys: categoryKeys,
	            startDate: startDate,
	            endDate: endDate,
	            start: 0,
	            end: _liferayWidgetsReactWeb.AppContext.DEFAULT_LIST_SIZE
	        });
	    }, [startDate, endDate, categoryKeys, useDateFilter]);
	
	    var toggleFilter = function toggleFilter(value, selected) {
	        return function () {
	            var categoryKeysArray = categoryKeys.split(',');
	            if (Array.isArray(value)) {
	                categoryKeysArray = selected ? categoryKeysArray.filter(function (key) {
	                    return value === key;
	                }) : Array.from(new Set([].concat(categoryKeysArray, value)));
	            } else {
	                categoryKeysArray = selected ? categoryKeysArray.filter(function (key) {
	                    return key !== value;
	                }) : [].concat(categoryKeysArray, [value]);
	            }
	            setCategoryKeys(categoryKeysArray.toString());
	        };
	    };
	
	    var allowExport = function allowExport(e) {
	        var differenceInCalendarDays = startDate && endDate ? _datefns2.default.differenceInCalendarDays(new Date(startDate), new Date(endDate)) : Infinity;
	        var allowed = Math.abs(differenceInCalendarDays) <= _Constants.MAX_JOURNAL_FILTER_DATE_RANGE_DAYS;
	        if (!allowed) {
	            window.alert('Für den Export muss ein Zeitraum von maximal 14 Tagen ausgewählt werden.');
	        }
	        return allowed;
	    };
	
	    var startEndDateChanged = function startEndDateChanged(_ref2) {
	        var startDate = _ref2.startDate,
	            endDate = _ref2.endDate;
	
	        setStartEndDate({ startDate: _datefns2.default.startOfDay(startDate), endDate: _datefns2.default.endOfDay(endDate) });
	    };
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'journal-portlet-filters py-3 border-right border-bottom', role: 'toolbar' },
	        _react2.default.createElement(
	            'div',
	            { className: 'd-flex mb-3 justify-content-between' },
	            _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                    className: 'd-lg-none',
	                    onClick: function onClick() {
	                        return setShowFilters(!showFilters);
	                    }
	                },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'd-flex align-items-center' },
	                    'Filter',
	                    _react2.default.createElement(_basePortlet.Icon, { name: showFilters ? 'arrow-down' : 'arrow-up', className: 'ml-2' })
	                )
	            ),
	            _react2.default.createElement(_basePortlet.PDFExportButton, {
	                baseUrl: window.journalExportUrl,
	                namespace: window.journalExportPortletNamespace,
	                title: 'Bericht erzeugen',
	                fileName: 'Journal',
	                allowExport: allowExport,
	                params: {
	                    startDate: startDate && startDate.getTime(),
	                    endDate: endDate && endDate.getTime(),
	                    categoryKeys: categoryKeys
	                }
	            })
	        ),
	        showFilters && _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'my-3 py-3 border-top border-bottom' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'h6 d-flex align-items-center' },
	                    'Datumsfilter'
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Form.Group,
	                    { controlId: 'date-filter-checkbox' },
	                    _react2.default.createElement(_reactBootstrap.Form.Check, {
	                        className: 'my-3',
	                        type: 'checkbox',
	                        checked: useDateFilter,
	                        onChange: function onChange(e) {
	                            return setUseDateFilter(e.target.checked);
	                        },
	                        label: 'Datumsfilter aktivieren'
	                    })
	                ),
	                _react2.default.createElement(_basePortlet.DateRangePicker, {
	                    dateFormat: 'dd.MM.yyyy',
	                    startDate: startDate,
	                    endDate: endDate,
	                    onChange: startEndDateChanged,
	                    disabled: !useDateFilter
	                })
	            ),
	            _FilterDefinitions.FILTER_DEFINITIONS.map(function (filter) {
	                return _react2.default.createElement(
	                    'div',
	                    { key: filter.label, className: 'mb-3' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'h6 d-block mb-3' },
	                        filter.label
	                    ),
	                    filter.options.map(function (o) {
	                        var checked = void 0;
	                        if (Array.isArray(o.value)) {
	                            checked = true;
	                            o.value.forEach(function (entry) {
	                                var singleChecked = false;
	                                categoryKeys.split(',').forEach(function (key) {
	                                    if (key === entry) {
	                                        singleChecked = true;
	                                        return;
	                                    }
	                                });
	                                if (!singleChecked) {
	                                    checked = false;
	                                }
	                            });
	                        } else {
	                            checked = false;
	                            categoryKeys.split(',').forEach(function (key) {
	                                if (key === o.value) {
	                                    checked = true;
	                                    return;
	                                }
	                            });
	                        }
	                        return _react2.default.createElement(
	                            _reactBootstrap.Form.Group,
	                            {
	                                key: 'filter-checkbox-' + o.value,
	                                controlId: 'filter-checkbox-' + o.value
	                            },
	                            _react2.default.createElement(_reactBootstrap.Form.Check, {
	                                type: 'checkbox',
	                                checked: checked,
	                                onChange: toggleFilter(o.value, checked),
	                                label: o.label
	                            })
	                        );
	                    })
	                );
	            })
	        )
	    );
	}; /**
	    * User: n.gorte
	    * Date: 14.09.2020
	    * Time: 16:03
	    */
	
	JournalFilters.propTypes = {
	    localConfigKey: _propTypes2.default.string,
	    listName: _propTypes2.default.string,
	    defaultCategoryKeys: _propTypes2.default.string,
	    dateFilterActive: _propTypes2.default.bool
	};

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_16__;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_17__;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FILTER_DEFINITIONS = undefined;
	
	var _Constants = __webpack_require__(5);
	
	var FILTER_DEFINITIONS = exports.FILTER_DEFINITIONS = [{
	    label: 'Mandanten-Objekte',
	    options: [{ value: _Constants.JournalEntryCategories.CHANGE_RECORD, label: 'Mandanten-Objekte anzeigen' }]
	}, {
	    label: 'Alarmstufen',
	    options: [{ value: _Constants.JournalEntryCategories.ALARMLEVEL_SET, label: 'Alarmstufen-Änderungen' }]
	}, {
	    label: 'Maßnahmenplan',
	    options: [{ value: _Constants.JournalEntryCategories.OPERATION_PLANNING, label: 'Maßnahmenplanung' }, { value: _Constants.JournalEntryCategories.ACTIVATION_MATRIX, label: 'Auslösematrix' }, { value: _Constants.JournalEntryCategories.TASK_MANAGEMENT, label: 'Maßnahmenausführung' }]
	}, {
	    label: 'Lagemeldung',
	    options: [{ value: _Constants.JournalEntryCategories.SITUATION_MESSAGE, label: 'Lagemeldungen' }]
	}, {
	    label: 'Manuelle Journaleinträge',
	    options: [{
	        value: [_Constants.JournalEntryCategories.ALARMLEVEL_MANUAL, _Constants.JournalEntryCategories.WATERLEVEL_MESSAGE, _Constants.JournalEntryCategories.WEATHER_WARNING, _Constants.JournalEntryCategories.WATER_LEVEL_CHART, _Constants.JournalEntryCategories.PRECIPITATION_STATION_CHART, _Constants.JournalEntryCategories.FRB_CHART, _Constants.JournalEntryCategories.WEBCAM, _Constants.JournalEntryCategories.REAL_PRECIPITATION_STATION_CHART],
	        label: 'Alle anzeigen'
	    }, { value: _Constants.JournalEntryCategories.ALARMLEVEL_MANUAL, label: 'Alarmstufen anderer Mandanten' }, { value: _Constants.JournalEntryCategories.WATERLEVEL_MESSAGE, label: 'Wasserstandsmeldungen' }, { value: _Constants.JournalEntryCategories.WEATHER_WARNING, label: 'Wetterwarnungen' }, { value: _Constants.JournalEntryCategories.WATER_LEVEL_CHART, label: 'Pegeldiagramme' }, { value: _Constants.JournalEntryCategories.PRECIPITATION_STATION_CHART, label: 'Radar Niederschlagsmessung' }, { value: _Constants.JournalEntryCategories.REAL_PRECIPITATION_STATION_CHART, label: 'Niederschlagsmessstation' }, { value: _Constants.JournalEntryCategories.FRB_CHART, label: 'HRB-Diagramme' }, { value: _Constants.JournalEntryCategories.WEBCAM, label: 'Inhalt von Webcam-Kachel' }]
	}, {
	    label: 'Lagekarte',
	    options: [{ value: 'SITUATION_MAP', label: 'Lagekarte' }]
	}];

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// journal-portlet.js